exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* For dropdown elements to display a redish background on hover instead of the default greyish which blends with the page background */\r\n.dropdown-menu.show > .dropdown-item:hover {\r\n    background-color: #f9eeee;\r\n}", ""]);

// exports
